export default __webpack_public_path__ + "static/media/document.6fe3e0a3.svg";